export default "__VITE_ASSET__QJMItBdF__"